import moment from 'moment';

/**
 * Calendar dates in this app are timezone-agnostic CALENDAR DAYS, not instants.
 * A chef who blocks "April 25" means the 25th everywhere on earth.
 *
 * NEVER use `new Date("2025-04-25")` for these. JS parses a date-only string as
 * UTC midnight, which renders as the PREVIOUS day in any UTC-negative timezone
 * (the entire US + western EU at some offsets). That is the ENG-272 bug.
 */
const DATE_ONLY = 'YYYY-MM-DD';

/** Parse a date-only string (YYYY-MM-DD) into a LOCAL-midnight Date - no TZ shift. */
export const parseCalendarDate = (value: string): Date => {
    const m = moment(value, DATE_ONLY, true);
    return m.isValid() ? m.toDate() : moment(value).toDate(); // tolerant fallback for full ISO / Date-like inputs
};

/** Format a Date (or date-like value) into a YYYY-MM-DD string in LOCAL time. */
export const formatCalendarDate = (value: Date | string): string =>
    moment(value).format(DATE_ONLY);
